declare const FRONT_CDN_HOST: string;

export const getStaticAssetUrl = (assetPath: string): string => {
  if (!assetPath.startsWith('/')) {
    throw new Error('assetPath should start with `/`');
  }
  return `https://${FRONT_CDN_HOST}${assetPath}`;
};

export const getPaybisIconsUrl = (assetPath: string): string => {
  if (!assetPath.startsWith('/')) {
    throw new Error('assetPath should start with `/`');
  }
  return `${PAYBIS_ICONS_BASE_URL}${assetPath}`;
};